export class NotFound extends Error {
  status = 404;
}
